const DEFAULT_API_BASE_OPERATOR = (process.env.REACT_APP_API_BASE_OPERATOR || "").trim().replace(/\/+$/, "");
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const CHAT_ARCHIVE_DAYS = Number(process.env.REACT_APP_CHAT_ARCHIVE_DAYS || 30);
export const SERVER_SELECTION_ENABLED = process.env.REACT_APP_ALLOW_SERVER_OVERRIDE === "1";

export const STORAGE_KEYS = {
    ACCESS_TOKEN: "WR_OPERATOR_ACCESS_TOKEN",
    FCM_TOKEN_ANDROID: "WR_OPERATOR_FCM_TOKEN_ANDROID",
    FCM_TOKEN_ANDROID_SENT: "WR_OPERATOR_FCM_TOKEN_ANDROID_SENT",
    LAST_PUSH: "WR_OPERATOR_LAST_PUSH",
    API_BASE_OVERRIDE: "WR_OPERATOR_API_BASE_OVERRIDE",
    SERVER_SELECTION_SEEN: "WR_OPERATOR_SERVER_SELECTION_SEEN",
};

function normalizeApiBase(value) {
    const normalized = (value || "").trim().replace(/\/+$/, "");
    if (!normalized) return "";

    let parsed;
    try {
        parsed = new URL(normalized);
    } catch (_) {
        throw new Error("Вкажіть повну адресу сервера у форматі https://domain.tld");
    }

    if (!["http:", "https:"].includes(parsed.protocol)) {
        throw new Error("Підтримуються лише http:// або https:// адреси сервера");
    }

    return parsed.toString().replace(/\/+$/, "");
}

function getStoredApiBaseOverride() {
    if (typeof window === "undefined") return "";
    try {
        return localStorage.getItem(STORAGE_KEYS.API_BASE_OVERRIDE) || "";
    } catch (_) {
        return "";
    }
}

function resolveApiBaseOperator() {
    return normalizeApiBase(getStoredApiBaseOverride()) || DEFAULT_API_BASE_OPERATOR;
}

export let API_BASE_OPERATOR = resolveApiBaseOperator();

export function isCapacitorRuntime() {
    try {
        return typeof window !== "undefined" && !!window.Capacitor;
    } catch (_) {
        return false;
    }
}

export function shouldAllowServerSelection() {
    return SERVER_SELECTION_ENABLED && isCapacitorRuntime();
}

export function getDefaultApiBaseOperator() {
    return DEFAULT_API_BASE_OPERATOR;
}

export function setApiBaseOperator(value) {
    const normalized = normalizeApiBase(value);
    try {
        localStorage.setItem(STORAGE_KEYS.API_BASE_OVERRIDE, normalized);
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
    API_BASE_OPERATOR = normalized;
    return API_BASE_OPERATOR;
}

export function resetApiBaseOperator() {
    try {
        localStorage.removeItem(STORAGE_KEYS.API_BASE_OVERRIDE);
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
    API_BASE_OPERATOR = DEFAULT_API_BASE_OPERATOR;
    return API_BASE_OPERATOR;
}

export function hasSeenServerSelection() {
    try {
        return localStorage.getItem(STORAGE_KEYS.SERVER_SELECTION_SEEN) === "1";
    } catch (_) {
        return false;
    }
}

export function markServerSelectionSeen() {
    try {
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
}

export function clearStoredAuthStateForServerChange() {
    try {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.FCM_TOKEN_ANDROID_SENT);
        localStorage.removeItem("operatorId");
        localStorage.removeItem("networkId");
        localStorage.removeItem("authEmail");
    } catch (_) {
        // ignore
    }
}